import api from '../api';

/**
 * Post export request with selected IDs
 * @param {string} url - The export URL to call
 * @param {string[]} selectedIds - The IDs of selected rows
 * @returns {Promise<{ url: string }>} The response containing the file URL to open
 */
export const postExport = async (url, selectedIds) => {
  const response = await api.post(url, { selectedIds });
  return response.data;
};
